// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {difference, get, keys, map, sortBy, startCase} from 'lodash';

// Components
import Button from '../core/button';
import Form from '../core/form';
import Textarea from '../core/textarea';
import Select from '../core/select';

// Contexts
import {FormContext} from '../../contexts/form-context';

// Styles
import './flag-metadata-issue-form.scss';

const formName = 'flagMetadataIssue';

function FlagMetadataIssueForm({className, editing, searchData, flaggedMetadataAddIssue}) {
    const getFormProps = () => ({
        className: classnames('flag-metadata-issue-form', className),
        fixedPositionedResponse: true,
        name: formName,
        resetOnSubmit: !editing,
        submitData: true,
    });

    const addIssue = () => {
        flaggedMetadataAddIssue();
    };

    const getFieldNames = () => sortBy(difference(keys(get(searchData, '0')), ['lastUpdate']));

    return (
        <Form {...getFormProps()}>
            <div className="flag-metadata-issue-form--input-fields">
                <Select
                    className="flag-metadata-issue-form--select"
                    label="Field"
                    name="fieldName"
                    validate={['required']}
                >
                    <option value="">Choose a Field</option>
                    {map(getFieldNames(), (fieldName) => (
                        <option key={fieldName} value={fieldName}>
                            {startCase(fieldName)}
                        </option>
                    ))}
                </Select>
                <Select
                    className="flag-metadata-issue-form--select"
                    label="Type"
                    name="issueType"
                    validate={['required']}
                >
                    <option value="">Choose a Type</option>
                    <option value="INVALID">Invalid</option>
                    <option value="MISSING">Missing</option>
                </Select>
                <Textarea
                    className="flag-metadata-issue-form--input"
                    label="Comment"
                    name="comment"
                    validate={['text']}
                />
            </div>
            <div className="flag-metadata-issue-form--controls">
                <FormContext.Consumer>
                    {({isFormValid}) => (
                        <Button
                            className="flag-metadata-issue-form--add-button"
                            disabled={!isFormValid()}
                            onClick={addIssue}
                        >
                            Add
                        </Button>
                    )}
                </FormContext.Consumer>
            </div>
        </Form>
    );
}

FlagMetadataIssueForm.propTypes = {
    className: PropTypes.string,
    editing: PropTypes.bool,
    flaggedMetadataAddIssue: PropTypes.func,
    searchData: PropTypes.array.isRequired,
};

export default FlagMetadataIssueForm;
